module.exports = __webpack_public_path__ + "img/index-comp-pic2.313ae853.png";